import 'css-chunksrc/client/pages/projectPage/kanbanPage/loader/column/task/tagList/styles.scss';export default {
  "tagList": "_tagList_1ersc_1",
  "list": "_list_1ersc_9",
  "tag": "_tag_1ersc_1"
};